export const Hours = [
    {
        id: "1",
        korean: '한 시',
        english: '1 o\'clock',
        romanization: 'han-si',
    },
    {
        id: "2",
        korean: '두 시',
        english: '2 o\'clock',
        romanization: 'du-si',
    },
    {
        id: "3",
        korean: '세 시',
        english: '3 o\'clock',
        romanization: 'se-si',
    },
    {
        id: "4",
        korean: '네 시',
        english: '4 o\'clock',
        romanization: 'ne-si',
    },
    {
        id: "5",
        korean: '다섯 시',
        english: '5 o\'clock',
        romanization: 'daseot-si',
    },
    {
        id: "6",
        korean: '여섯 시',
        english: '6 o\'clock',
        romanization: 'yeoseot-si',
    },
    {
        id: "7",
        korean: '일곱 시',
        english: '7 o\'clock',
        romanization: 'ilgop-si',
    },
    {
        id: "8",
        korean: '여덟 시',
        english: '8 o\'clock',
        romanization: 'yeodeolb-si',
    },
    {
        id: "9",
        korean: '아홉 시',
        english: '9 o\'clock',
        romanization: 'ahop-si',
    },
    {
        id: "10",
        korean: '열 시',
        english: '10 o\'clock',
        romanization: 'yeol-si',
    },
    {
        id: "11",
        korean: '열한 시',
        english: '11 o\'clock',
        romanization: 'yeolhan-si',
    },
    {
        id: "12",
        korean: '열두 시',
        english: '12 o\'clock',
        romanization: 'yeoldu-si',
    },
];

export const Minutes = [
    {
        id: "0",
        korean: '영 분',
        english: '0 minutes',
        romanization: 'yeong-bun',
    },
    {
        id: "5",
        korean: '오 분',
        english: '5 minutes',
        romanization: 'o-bun',
    },
    {
        id: "10",
        korean: '십 분',
        english: '10 minutes',
        romanization: 'sip-bun',
    },
    {
        id: "15",
        korean: '십오 분',
        english: '15 minutes',
        romanization: 'sipo-bun',
    },
    {
        id: "20",
        korean: '이십 분',
        english: '20 minutes',
        romanization: 'isip-bun',
    },
    {
        id: "25",
        korean: '이십오 분',
        english: '25 minutes',
        romanization: 'isipo-bun',
    },
    {
        id: "30",
        korean: '삼십 분',
        english: '30 minutes',
        romanization: 'samsip-bun',
    },
    {
        id: "35",
        korean: '삼십오 분',
        english: '35 minutes',
        romanization: 'samsipo-bun',
    },
    {
        id: "40",
        korean: '사십 분',
        english: '40 minutes',
        romanization: 'sasip-bun',
    },
    {
        id: "45",
        korean: '사십오 분',
        english: '45 minutes',
        romanization: 'sasipo-bun',
    },
    {
        id: "50",
        korean: '오십 분',
        english: '50 minutes',
        romanization: 'osip-bun',
    },
    {
        id: "55",
        korean: '오십오 분',
        english: '55 minutes',
        romanization: 'osipo-bun',
    },
];

export const TimeWords = [
    {
        id: "quarter-past",
        korean: '15분 후',
        english: 'quarter past',
        romanization: 'sip-o-bun-hu',
    },
    {
        id: "half-past",
        korean: '30분 후',
        english: 'half past',
        romanization: 'sam-sip-bun-hu',
    },
    {
        id: "quarter-to",
        korean: '15분 전',
        english: 'quarter to',
        romanization: 'sip-o-bun-jeon',
    },
    {
        id: "ten-past",
        korean: '10분 후',
        english: 'ten past',
        romanization: 'sip-bun-hu',
    },
    {
        id: "five-past",
        korean: '5분 후',
        english: 'five past',
        romanization: 'o-bun-hu',
    },
    {
        id: "ten-to",
        korean: '10분 전',
        english: 'ten to',
        romanization: 'sip-bun-jeon',
    },
    {
        id: "five-to",
        korean: '5분 전',
        english: 'five to',
        romanization: 'o-bun-jeon',
    },
    {
        id: "noon",
        korean: '정오',
        english: 'noon',
        romanization: 'jeong-o',
    },
    {
        id: "midnight",
        korean: '자정',
        english: 'midnight',
        romanization: 'ja-jeong',
    },
];

export const HoursMins = [
    {
        id: "1-00",
        korean: '한 시 정각',
        english: '1:00',
        romanization: 'han-si jeong-gak',
    },
    {
        id: "1-15",
        korean: '한 시 십오 분 후',
        english: '1:15 (quarter past one)',
        romanization: 'han-si sip-o-bun hu',
    },
    {
        id: "1-30",
        korean: '한 시 삼십 분 후',
        english: '1:30 (half past one)',
        romanization: 'han-si sam-sip-bun hu',
    },
    {
        id: "1-45",
        korean: '두 시 십오 분 전',
        english: '1:45 (quarter to two)',
        romanization: 'du-si sip-o-bun jeon',
    },
    {
        id: "2-00",
        korean: '두 시 정각',
        english: '2:00',
        romanization: 'du-si jeong-gak',
    },
    {
        id: "2-15",
        korean: '두 시 십오 분 후',
        english: '2:15 (quarter past two)',
        romanization: 'du-si sip-o-bun hu',
    },
    {
        id: "2-30",
        korean: '두 시 삼십 분 후',
        english: '2:30 (half past two)',
        romanization: 'du-si sam-sip-bun hu',
    },
    {
        id: "2-45",
        korean: '세 시 십오 분 전',
        english: '2:45 (quarter to three)',
        romanization: 'se-si sip-o-bun jeon',
    },
    {
        id: "3-00",
        korean: '세 시 정각',
        english: '3:00',
        romanization: 'se-si jeong-gak',
    },
    {
        id: "3-15",
        korean: '세 시 십오 분 후',
        english: '3:15 (quarter past three)',
        romanization: 'se-si sip-o-bun hu',
    },
    {
        id: "3-30",
        korean: '세 시 삼십 분 후',
        english: '3:30 (half past three)',
        romanization: 'se-si sam-sip-bun hu',
    },
    {
        id: "3-45",
        korean: '네 시 십오 분 전',
        english: '3:45 (quarter to four)',
        romanization: 'ne-si sip-o-bun jeon',
    },
   
    // 4 o'clock
    { id: "4-00", korean: '네 시 정각', english: '4:00', romanization: 'ne-si jeong-gak' },
    { id: "4-15", korean: '네 시 십오 분 후', english: '4:15 (quarter past four)', romanization: 'ne-si sip-o-bun hu' },
    { id: "4-30", korean: '네 시 삼십 분 후', english: '4:30 (half past four)', romanization: 'ne-si sam-sip-bun hu' },
    { id: "4-45", korean: '다섯 시 십오 분 전', english: '4:45 (quarter to five)', romanization: 'daseot-si sip-o-bun jeon' },

    // 5 o'clock
    { id: "5-00", korean: '다섯 시 정각', english: '5:00', romanization: 'daseot-si jeong-gak' },
    { id: "5-15", korean: '다섯 시 십오 분 후', english: '5:15 (quarter past five)', romanization: 'daseot-si sip-o-bun hu' },
    { id: "5-30", korean: '다섯 시 삼십 분 후', english: '5:30 (half past five)', romanization: 'daseot-si sam-sip-bun hu' },
    { id: "5-45", korean: '여섯 시 십오 분 전', english: '5:45 (quarter to six)', romanization: 'yeoseot-si sip-o-bun jeon' },

    // 6 o'clock
    { id: "6-00", korean: '여섯 시 정각', english: '6:00', romanization: 'yeoseot-si jeong-gak' },
    { id: "6-15", korean: '여섯 시 십오 분 후', english: '6:15 (quarter past six)', romanization: 'yeoseot-si sip-o-bun hu' },
    { id: "6-30", korean: '여섯 시 삼십 분 후', english: '6:30 (half past six)', romanization: 'yeoseot-si sam-sip-bun hu' },
    { id: "6-45", korean: '일곱 시 십오 분 전', english: '6:45 (quarter to seven)', romanization: 'ilgop-si sip-o-bun jeon' },

    // 7 o'clock
    { id: "7-00", korean: '일곱 시 정각', english: '7:00', romanization: 'ilgop-si jeong-gak' },
    { id: "7-15", korean: '일곱 시 십오 분 후', english: '7:15 (quarter past seven)', romanization: 'ilgop-si sip-o-bun hu' },
    { id: "7-30", korean: '일곱 시 삼십 분 후', english: '7:30 (half past seven)', romanization: 'ilgop-si sam-sip-bun hu' },
    { id: "7-45", korean: '여덟 시 십오 분 전', english: '7:45 (quarter to eight)', romanization: 'yeodeolb-si sip-o-bun jeon' },

    // 8 o'clock
    { id: "8-00", korean: '여덟 시 정각', english: '8:00', romanization: 'yeodeolb-si jeong-gak' },
    { id: "8-15", korean: '여덟 시 십오 분 후', english: '8:15 (quarter past eight)', romanization: 'yeodeolb-si sip-o-bun hu' },
    { id: "8-30", korean: '여덟 시 삼십 분 후', english: '8:30 (half past eight)', romanization: 'yeodeolb-si sam-sip-bun hu' },
    { id: "8-45", korean: '아홉 시 십오 분 전', english: '8:45 (quarter to nine)', romanization: 'ahop-si sip-o-bun jeon' },

    // 9 o'clock
    { id: "9-00", korean: '아홉 시 정각', english: '9:00', romanization: 'ahop-si jeong-gak' },
    { id: "9-15", korean: '아홉 시 십오 분 후', english: '9:15 (quarter past nine)', romanization: 'ahop-si sip-o-bun hu' },
    { id: "9-30", korean: '아홉 시 삼십 분 후', english: '9:30 (half past nine)', romanization: 'ahop-si sam-sip-bun hu' },
    { id: "9-45", korean: '열 시 십오 분 전', english: '9:45 (quarter to ten)', romanization: 'yeol-si sip-o-bun jeon' },

    // 10 o'clock
    { id: "10-00", korean: '열 시 정각', english: '10:00', romanization: 'yeol-si jeong-gak' },
    { id: "10-15", korean: '열 시 십오 분 후', english: '10:15 (quarter past ten)', romanization: 'yeol-si sip-o-bun hu' },
    { id: "10-30", korean: '열 시 삼십 분 후', english: '10:30 (half past ten)', romanization: 'yeol-si sam-sip-bun hu' },
    { id: "10-45", korean: '열한 시 십오 분 전', english: '10:45 (quarter to eleven)', romanization: 'yeolhan-si sip-o-bun jeon' },

    // 11 o'clock
    { id: "11-00", korean: '열한 시 정각', english: '11:00', romanization: 'yeolhan-si jeong-gak' },
    { id: "11-15", korean: '열한 시 십오 분 후', english: '11:15 (quarter past eleven)', romanization: 'yeolhan-si sip-o-bun hu' },
    { id: "11-30", korean: '열한 시 삼십 분 후', english: '11:30 (half past eleven)', romanization: 'yeolhan-si sam-sip-bun hu' },
    { id: "11-45", korean: '열두 시 십오 분 전', english: '11:45 (quarter to twelve)', romanization: 'yeoldu-si sip-o-bun jeon' },

    // 12 o'clock
    { id: "12-00", korean: '열두 시 정각', english: '12:00', romanization: 'yeoldu-si jeong-gak' },
    { id: "12-15", korean: '열두 시 십오 분 후', english: '12:15 (quarter past twelve)', romanization: 'yeoldu-si sip-o-bun hu' },
    { id: "12-30", korean: '열두 시 삼십 분 후', english: '12:30 (half past twelve)', romanization: 'yeoldu-si sam-sip-bun hu' },
    { id: "12-45", korean: '한 시 십오 분 전', english: '12:45 (quarter to one)', romanization: 'han-si sip-o-bun jeon' },


];

export const PartsOfTheDay = [
    {
        id: "morning",
        korean: '아침',
        english: 'morning',
        romanization: 'a-chim',
    },
    {
        id: "late-morning",
        korean: '늦은 아침',
        english: 'late morning',
        romanization: 'neujeun a-chim',
    },
    {
        id: "noon",
        korean: '정오',
        english: 'noon',
        romanization: 'jeong-o',
    },
    {
        id: "afternoon",
        korean: '오후',
        english: 'afternoon',
        romanization: 'o-hu',
    },
    {
        id: "evening",
        korean: '저녁',
        english: 'evening',
        romanization: 'jeo-nyeok',
    },
    {
        id: "night",
        korean: '밤',
        english: 'night',
        romanization: 'bam',
    },
    {
        id: "midnight",
        korean: '자정',
        english: 'midnight',
        romanization: 'ja-jeong',
    },
];

export const DaysOfTheWeek = [
    // Days of the week
    { id: "monday", korean: '월요일', english: 'Monday', romanization: 'wol-yo-il' },
    { id: "tuesday", korean: '화요일', english: 'Tuesday', romanization: 'hwa-yo-il' },
    { id: "wednesday", korean: '수요일', english: 'Wednesday', romanization: 'su-yo-il' },
    { id: "thursday", korean: '목요일', english: 'Thursday', romanization: 'mok-yo-il' },
    { id: "friday", korean: '금요일', english: 'Friday', romanization: 'geum-yo-il' },
    { id: "saturday", korean: '토요일', english: 'Saturday', romanization: 'to-yo-il' },
    { id: "sunday", korean: '일요일', english: 'Sunday', romanization: 'il-yo-il' },
];

export const Months = [
    // Months
    { id: "january", korean: '1월', english: 'January', romanization: 'il-wol' },
    { id: "february", korean: '2월', english: 'February', romanization: 'i-wol' },
    { id: "march", korean: '3월', english: 'March', romanization: 'sam-wol' },
    { id: "april", korean: '4월', english: 'April', romanization: 'sa-wol' },
    { id: "may", korean: '5월', english: 'May', romanization: 'o-wol' },
    { id: "june", korean: '6월', english: 'June', romanization: 'yuk-wol' },
    { id: "july", korean: '7월', english: 'July', romanization: 'chil-wol' },
    { id: "august", korean: '8월', english: 'August', romanization: 'pal-wol' },
    { id: "september", korean: '9월', english: 'September', romanization: 'gu-wol' },
    { id: "october", korean: '10월', english: 'October', romanization: 'sip-wol' },
    { id: "november", korean: '11월', english: 'November', romanization: 'sip-il-wol' },
    { id: "december", korean: '12월', english: 'December', romanization: 'sip-i-wol' },
];

export const Durations = [
    // Seconds
    { id: "second", korean: '초', english: 'second', romanization: 'cho' },
    { id: "seconds", korean: '초', english: 'seconds', romanization: 'cho' },

    // Minutes
    { id: "minute", korean: '분', english: 'minute', romanization: 'bun' },
    { id: "minutes", korean: '분', english: 'minutes', romanization: 'bun' },

    // Hours
    { id: "hour", korean: '시간', english: 'hour', romanization: 'si-gan' },
    { id: "hours", korean: '시간', english: 'hours', romanization: 'si-gan' },

    // Days
    { id: "day", korean: '일', english: 'day', romanization: 'il' },
    { id: "days", korean: '일', english: 'days', romanization: 'il' },

    // Weeks
    { id: "week", korean: '주', english: 'week', romanization: 'ju' },

    // Months
    { id: "month", korean: '개월', english: 'month', romanization: 'gae-wol' },

    // Years
    { id: "year", korean: '년', english: 'year', romanization: 'nyeon' },

    // Common expressions
    { id: "for-30-minutes", korean: '30분 동안', english: 'for 30 minutes', romanization: 'sam-sip-bun dong-an' },
    { id: "takes-2-hours", korean: '2시간 걸리다', english: 'takes 2 hours', romanization: 'i-si-gan geol-li-da' },
    { id: "all-day", korean: '하루 종일', english: 'all day', romanization: 'ha-ru jong-il' },
];
